import {
  Component,
  Host,
  h,
  Prop,
} from "@stencil/core";

import { StzhBadgeType } from "../../index";

/**
 * @slot - Slot badge content
 */
@Component({
  tag: "stzh-badge",
  styleUrl: "stzh-badge.scss",
  scoped: true
})
export class StzhBadge {
  /** Text content of the badge */
  @Prop() label: string = "";

  /** Type */
  @Prop({ reflect: true }) type: StzhBadgeType = "default";

  render() {
    const classes = {
      "stzh-badge": true,
      [`stzh-badge--type-${this.type}`]: !!this.type
    };

    return (
      <Host filled={!!this.label}>
        <div class={classes}>
          {this.label || <slot></slot>}
        </div>
      </Host>
    );
  }
}
